// const exportUrl ='https://sportingbharat.com/SV/dev/backend/'
const exportUrl = "https://sah.sportzvillage.com/dev/backend/";

export default exportUrl; 